import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

import { Badge } from '@cfa/react-components';
import { selectCartItemsLength } from '../../cart/selectors';
import Icon from '../Icon';
import { selectTaxAndTotal } from '../../shared/selectors';
import { selectOrderIsLoading } from '../../order/selectors';

const CartLink: React.FC = () => {
  const cartItemCount = useSelector(selectCartItemsLength);
  const total = useSelector(selectTaxAndTotal);
  const loading = useSelector(selectOrderIsLoading);

  return (
    <StyledCartLink>
      <NavLink to={{ state: { modal: true } }}>
        <Badge
          className="badge"
          color="secondary"
          content={cartItemCount}
          data-cy="cart-badge"
          hide={!cartItemCount}
          overlap="circular"
        >
          <Icon>bag</Icon>
          {loading ? (
            <div className="total loading">Calculating</div>
          ) : (
            <div className="total" data-cy="total">
              {total}
            </div>
          )}
        </Badge>
      </NavLink>
    </StyledCartLink>
  );
};

const StyledCartLink = styled.div`
  position: relative;
  min-width: 55px;
  border-radius: 2px;

  & a {
    text-decoration: none;
  }

  & svg {
    fill: ${(props) => props.theme.colors.primary};
  }

  & .badge {
    z-index: 200;
    display: unset;
  }

  & .badge > span {
    bottom: 32px;
    top: auto;
  }

  & .badge > div {
    top: 3px;
  }

  & .total {
    position: absolute;
    right: 10px;
    bottom: 3px;
    color: ${(props) => props.theme.colors.primary};
    font: ${(props) => props.theme.smallTextFont};
  }

  & .loading {
    right: -3px;
    color: ${(props) => props.theme.colors.disabled};
  }

  & .cfa-badge {
    height: 22px;
    width: 22px;
    border-radius: 50%;
  }
`;

export default CartLink;
